var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageBubbleQuick = function SvgMessageBubbleQuick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.5 21.308v-4.823h-.086q-2.458-.123-4.186-1.83Q2.5 12.95 2.5 10.5q0-2.514 1.743-4.252T8.5 4.51h1.358L8.023 2.66l1.054-1.054 3.654 3.654-3.654 3.653L8.023 7.86l1.835-1.85H8.5q-1.875 0-3.187 1.307Q4 8.625 4 10.5q0 1.904 1.394 3.202Q6.79 15 8.721 15H10v2.685L12.675 15H15.5q1.875 0 3.192-1.312T20.01 10.5t-1.317-3.188T15.5 6h-.404V4.5h.404q2.513 0 4.262 1.743 1.747 1.743 1.747 4.257t-1.747 4.257T15.5 16.5h-2.192z"
  })));
};
export default SvgMessageBubbleQuick;